

import React from 'react'
import "./Footer.css";

export default function Footer() {
    return (

        <footer class="w3-container w3-center  " >
            <p style={{ textAlign: 'center', color: "white" }} className="pt-1">Find us on.</p>

            <ul class="socials">
                <li><a href="/" target="_blank"><i class="fa fa-instagram"></i></a></li>
                <li><a href="/" target="_blank"><i class="fa fa-twitter"></i></a></li>
                <li><a href="/" target="_blank"><i class="fa fa-github"></i></a></li>
                <li><a href="/" target="_blank"><i class="fa fa-linkedin"></i></a></li>
            </ul>
            <div className="footer-copyright text-center py-1" style={{ color: "White" }}>© 2022 Copyright:
                Aao Code Kare | Designed by <a style={{ textDecoration: 'none' }} href="https://www.linkedin.com/in/sasin-nisar-ai">Sasin Nisar</a> and Developed by <a style={{ textDecoration: 'none' }} href="https://www.linkedin.com/in/milan-rajani-642a36226">Milan Rajani</a>
            </div>



        </footer>

    )
}
